<div class="alert alert-danger">
	<a href="{{backToHomepageUrl}}"><button class="btn btn-primary">{{{JspPublicCodes_JSP_BACK_TO_HOMEPAGE}}}</button></a>
	<div class="row">
		<div class="col-md-12">{{{content}}}</div>
	</div>
</div> 